import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './BankAccountCard.module.css';
import cardStyles from '../../../styles/variables/cards.module.css';
import messages from './BankAccountCard.messages';
import classNames from 'classnames';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';
import { Button, Modal } from '@iwoca/orion';
import { EditSVG } from '@svgComponents/editSVG';

export class BankAccountCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUpdateBankAccountModal: false
        };
    }

    hideUpdateBankAccountModal = () => {
        this.setState({
            showUpdateBankAccountModal: false
        });
    };

    showUpdateBankAccountModal = () => {
        this.setState({
            showUpdateBankAccountModal: true
        });
    };

    renderBankDetails(accountNumber, sortCode) {
        if (getCountry() === 'DE') {
            return (
                <div className={styles.accountNumber} data-testid="bank-iban">
                    <FormattedMessage {...messages.IBANNumber} />{' '}
                    <span className="fs-exclude">{accountNumber}</span>
                </div>
            );
        }

        return (
            <>
                <div
                    className={styles.accountNumber}
                    data-testid="bank-account-number"
                >
                    <FormattedMessage {...messages.bankAccountNumber} />{' '}
                    <span className="fs-exclude">{accountNumber}</span>
                </div>
                <div className={styles.sortCode} data-testid="bank-sort-code">
                    <FormattedMessage {...messages.sortCode} />{' '}
                    <span className="fs-exclude">{sortCode}</span>
                </div>
            </>
        );
    }

    render() {
        const { accountNumber, sortCode, updateBankAccount } = this.props;
        const bankAccountCardStyles = classNames(
            styles.BankAccountCard,
            cardStyles.card
        );

        const showUpdateBankAccountButton = getCountry() === 'UK';

        return (
            <>
                <Modal
                    title="Update your bank account"
                    subTitle="This will open a form to add new bank details."
                    isOpen={this.state.showUpdateBankAccountModal}
                    onClose={this.hideUpdateBankAccountModal}
                    closeIcon
                >
                    <div className="flex justify-end">
                        <Button
                            variant="tertiary"
                            onClick={this.hideUpdateBankAccountModal}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="action"
                            onClick={() => {
                                updateBankAccount();
                                this.hideUpdateBankAccountModal();
                            }}
                        >
                            Update
                        </Button>
                    </div>
                </Modal>
                <div className={bankAccountCardStyles}>
                    <div className={styles.content}>
                        <div className={styles.description}>
                            <div className={styles.type}>
                                <FormattedMessage {...messages.bankAccount} />
                                {showUpdateBankAccountButton && (
                                    <button
                                        className="border-none bg-transparent fill-primary-10 stroke-primary-10 hover:cursor-pointer"
                                        onClick={
                                            this.showUpdateBankAccountModal
                                        }
                                        data-testid="update-bank-account"
                                    >
                                        <EditSVG className="h-4 w-4" />
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className={styles.bankAccountInfoText}>
                            <FormattedMessage
                                {...messages.bankAccountInfoText}
                            />
                        </div>

                        {this.renderBankDetails(accountNumber, sortCode)}

                        {getCountry() === 'DE' && (
                            <div className={styles.changeAccountDetails}>
                                <p>
                                    Um Ihre Kontodaten zu ändern, melden Sie
                                    sich bitte telefonisch bei uns: 069 /
                                    94323020
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    }
}
